/**
 * Gruppkraft — scroll-driven tidslinje ("Så fungerar det"-sidan m.fl.)
 *
 * Kräver GSAP + ScrollTrigger (självhostade tema-assets, laddas i
 * sections/timeline.liquid). Progressive enhancement: om GSAP saknas eller
 * användaren föredrar reducerad rörelse initieras ingenting — tidslinjen
 * visas då statisk med fylld linje och alla steg synliga.
 *
 * Beteende: när tidslinjen scrollas genom vyn ritas linjen i takt med
 * scrollen, passerade steg fylls i, det aktuella steget får en glödande
 * punkt och kommande steg ligger nedtonade.
 */
(function () {
  "use strict";

  function initAll() {
    document.querySelectorAll("[data-timeline]").forEach(initTimeline);
  }

  function initTimeline(root) {
    if (root.dataset.timelineInit === "1") return;
    root.dataset.timelineInit = "1";

    var items = Array.prototype.slice.call(
      root.querySelectorAll(".timeline__item")
    );
    var fill = root.querySelector("[data-timeline-fill]");
    var count = items.length;
    if (!count) return;

    if (
      window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
      !window.gsap ||
      !window.ScrollTrigger
    ) {
      return; // statisk fallback — CSS-grundläget är redan komplett
    }

    gsap.registerPlugin(ScrollTrigger);
    root.classList.add("timeline--ready");

    var current = -1;

    function setActive(index) {
      if (index === current) return;
      current = index;
      items.forEach(function (item, i) {
        item.classList.toggle("is-active", i === index);
        item.classList.toggle("is-passed", i < index);
      });
    }

    ScrollTrigger.create({
      trigger: root,
      start: "top 72%",
      end: "bottom 45%",
      onUpdate: function (self) {
        if (fill) gsap.set(fill, { scaleY: self.progress });
        var index = Math.min(count - 1, Math.floor(self.progress * count));
        setActive(index);
      },
    });

    setActive(0);
    if (fill) gsap.set(fill, { scaleY: 0 });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  /* Theme Editor: initiera om när sektionen laddas om i customizern */
  document.addEventListener("shopify:section:load", function (event) {
    var el = event.target.querySelector("[data-timeline]");
    if (el) {
      delete el.dataset.timelineInit;
      initTimeline(el);
      if (window.ScrollTrigger) ScrollTrigger.refresh();
    }
  });
})();
